import React from 'react';
import './HazardousWasteLicensing.css';
import Header4 from '../../components/header/header4/Header4';
import ServicesHeroSection from '../../components/services_hero_section/ServicesHeroSection';
import hw_dummy_1 from '../../assets/images/hazadeous-waste-1.jpg';
import Footer from '../../components/footer/Footer';
import ServicesOverviewSection from '../../components/services_overview_section/ServicesOverviewSection';
import img_hw_banner from '../../assets/images/img_peso1_banner.png';
import { FaRecycle, FaFileAlt, FaShieldAlt, FaCogs, FaComments, FaPaperPlane, FaCertificate } from 'react-icons/fa';
import ServicesBenefitsSection from '../../components/services_benefits_section/ServicesBenefitsSection';
import ServicesOurProcessSection from '../../components/services_our_process_section/ServicesOurProcessSection';
import ActsAndRulesSection from '../../components/acts_rules_section/ActsAndRulesSection';
import DocumentChecklist from '../../components/check_list_section/CheckListSection';

export default function HazardousWasteLicensing() {
  const hwBenefits = [
    {
      icon: <FaRecycle />,
      title: 'Environmental Compliance',
      text: 'Ensure safe disposal and management of hazardous waste.',
    },
    {
      icon: <FaFileAlt />,
      title: 'Legal Assurance',
      text: 'Avoid penalties and ensure compliance with waste management regulations.',
    },
    {
      icon: <FaShieldAlt />,
      title: 'Community Safety',
      text: 'Minimize risks to public health and the environment.',
    },
    {
      icon: <FaCogs />,
      title: 'Streamlined Processes',
      text: 'Efficiently manage hazardous waste with proper licensing.',
    },
  ];

  const steps = [
    {
      icon: <FaComments />,
      title: 'Consultation',
      description: 'Understand the hazardous waste management requirements for your business.',
    },
    {
      icon: <FaFileAlt />,
      title: 'Document Preparation',
      description: 'Compile and prepare necessary documents for licensing.',
    },
    {
      icon: <FaRecycle />,
      title: 'Waste Assessment',
      description: 'Evaluate waste types and quantities for proper classification.',
    },
    {
      icon: <FaPaperPlane />,
      title: 'Application Submission',
      description: 'Submit the hazardous waste license application to the relevant authorities.',
    },
    {
      icon: <FaCertificate />,
      title: 'License Issuance',
      description: 'Receive your license to manage hazardous waste in compliance with the law.',
    },
  ];

  const acts = [
    "Hazardous and Other Wastes (Management and Transboundary Movement) Rules, 2016",
    "Environment Protection Act, 1986",
    "Water (Prevention and Control of Pollution) Act, 1974",
    "Air (Prevention and Control of Pollution) Act, 1981"
  ];

  const explanation = "These regulations ensure the proper handling, storage, and disposal of hazardous waste to protect public health and the environment.";

  const checklistItems = [
    { name: 'Waste Inventory', description: 'Detailed inventory of hazardous waste generated by the business.' },
    { name: 'Proof of Disposal Methods', description: 'Documentation showing the waste disposal methods used.' },
    { name: 'Company Registration Documents', description: 'Incorporation certificate and applicable business licenses.' },
    { name: 'Pollution Control Board Approval', description: 'Approval or acknowledgment from the local pollution control board.' },
  ];

  return (
    <>
      <Header4 />
      <ServicesHeroSection
        headline="Hazardous Waste Licensing Services"
        subheading="Ensure proper and lawful management of hazardous waste with our licensing services."
        ctaPrimary={{ text: "Request Consultation", link: "/contact-us" }}
        ctaSecondary={{ text: "Learn More", link: "/hazardous-waste-licensing" }}
        backgroundImage={hw_dummy_1}
      />

      <ServicesOverviewSection
        title="What is Hazardous Waste Licensing?"
        description="Hazardous waste licensing ensures businesses follow proper protocols for the safe handling, storage, and disposal of hazardous materials, minimizing environmental impact."
        image={img_hw_banner}
        altText="Hazardous Waste Licensing"
      />

      <ServicesBenefitsSection
        title="Why You Need Hazardous Waste Licensing"
        description="Understand the benefits of hazardous waste licensing for your business and community."
        benefits={hwBenefits}
      />

      <ActsAndRulesSection
        title="Acts and Rules Covered"
        subtitle="Key Regulations Governing Hazardous Waste Management"
        acts={acts}
        explanation={explanation}
      />

      <ServicesOurProcessSection
        title="Our Simple Hazardous Waste Licensing Process"
        steps={steps}
      />

      <DocumentChecklist
        mainTitle="Complete Your Onboarding"
        checklistTitle="Hazardous Waste Licensing Document Checklist"
        items={checklistItems}
      />

      <Footer />
    </>
  );
}
